import { styled } from '@linaria/react';

import {
  DarkWrapper,
  type Props as ColorModeProps,
} from '@/components/ColorModeContainer';

type Props = Omit<ColorModeProps, 'colorMode'>;

const Space = styled(DarkWrapper)<Props>`
  border-radius: 8px;
  background-color: var(--color-background);
  color: var(--color-text);
  color-scheme: dark;
`;

export default Space;
